import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class ProjectInternalOrderAttachmentAPI {
    public static async upload(projectInternalOrderId: string, file: Blob, documentType: string | null) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('project_internal_order_id', projectInternalOrderId);
        if (documentType) {
            formData.append('document_type', documentType);
        }

        let attachment;
        try {
            attachment = (await ApiController.post(ApiRoutes.projectInternalOrderAttachment.create, formData)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(attachment);
    }

    public static async delete(attachmentId: string) {
        try {
            await ApiController.delete(ApiRoutes.projectInternalOrderAttachment.delete(attachmentId));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }
}